const Contacto = () => {
  return (
    <section className="bg-cream py-20 px-6 md:px-20" id="contacto">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs tracking-[0.35em] uppercase text-terracotta mb-2">Contacto</p>
        <h2 className="text-3xl md:text-4xl font-serif tracking-wide text-ink mb-10">Ven a visitarnos</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          <div className="text-ink">
            <p className="mb-4">
              <span className="block text-[11px] font-medium tracking-[0.3em] uppercase text-terracotta mb-1">
                Dirección
              </span>
              Av. del Segle XXI, 57B
              <br />
              08840 Viladecans, Barcelona
            </p>

            <p className="mb-4">
              <span className="block text-[11px] font-medium tracking-[0.3em] uppercase text-terracotta mb-1">
                Teléfono
              </span>
              642 38 89 97
            </p>

            <p className="mb-4">
              <span className="block text-[11px] font-medium tracking-[0.3em] uppercase text-terracotta mb-1">
                Instagram
              </span>
              <a
                href="https://www.instagram.com/origin.beyond_pilates/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-terracotta-dark transition-colors"
              >
                origin.beyond_pilates
              </a>
            </p>

            <a
              href="tel:642388997"
              className="inline-block mt-2 rounded-full border border-terracotta text-terracotta hover:bg-terracotta hover:text-cream px-8 py-3 text-xs uppercase tracking-[0.25em] transition"
            >
              Llamar
            </a>
          </div>

          <div>
            <div className="w-full h-[400px] md:h-[450px] rounded-md overflow-hidden shadow-lg border border-sand">
              <iframe
                title="Ubicación Origin Beyond Pilates"
                src="https://www.google.com/maps?cid=6859197570022636694&output=embed"
                className="w-full h-full"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <a
              href="https://www.google.com/maps/place/Origin+Beyond+Pilates/data=!4m2!3m1!1s0x0:0x5f30c3d92d6bfc96?sa=X&ved=1t:2428&ictx=111"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-4 text-xs uppercase tracking-[0.25em] text-terracotta hover:text-terracotta-dark transition"
            >
              Ver en Google Maps
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacto;
